import React, { createContext, useState, useContext, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
    return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [token, setToken] = useState(localStorage.getItem('token'));

    useEffect(() => {
        console.info("UseEffect token value: ", token);
        if (token) {
            // Verify token and get user info
            const verifyToken = async () => {
                try {
                    // You might want to add a /me endpoint to get user info
                    localStorage.setItem('token', token);
                    // Set basic user info from token (in production, fetch from /me endpoint)
                    const payload = JSON.parse(atob(token.split('.')[1]));
                    console.info("UseEffect user value: ", payload.sub);
                    setUser({ email: payload.sub });
                } catch (error) {
                    localStorage.removeItem('token');
                    setToken(null);
                }
                setLoading(false);
            };
            verifyToken();
        } else {
            setLoading(false);
        }
    }, [token]);

    const login = async (email, password) => {
        try {
            console.info("auth login function call from AuthContext");
            const response = await authAPI.login(email, password);
            const { access_token } = response.data;
            setToken(access_token);
            localStorage.setItem('token', access_token);
            console.info("auth login function Response from Login: ", response);
            return { success: true };
        } catch (error) {
            return { 
                success: false, 
                error: error.response?.data?.detail || 'Login failed' 
            };
        }
    };

    const register = async (userData) => {
        try {
            await authAPI.register(userData);
            return { success: true };
        } catch (error) {
            return { 
                success: false, 
                error: error.response?.data?.detail || 'Registration failed' 
            };
        }
    };

    const logout = () => {
        setToken(null);
        setUser(null);
        localStorage.removeItem('token');
    };

    const validateCurrentUser = async () => {
        try {
            const response = await authAPI.validateUser();
            setUser(response.data);
            return { success: true, user: response.data };
        } catch (error) {
            logout(); // Auto-logout if validation fails
            return { success: false, error: 'Session expired' };
        }
    };    

    const value = {
        user,
        login,
        register,
        logout,
        validateCurrentUser,
        isAuthenticated: !!token,
        loading
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};